import { Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { getOrganization } from 'portal/src/api/OrganizationsService';
import { IAuthorizationContext } from 'portal/src/auth/IAuthorizationContext';
import useAuth from 'portal/src/auth/useAuth';
import OrganizationForm from 'portal/src/components/systemAdministration/Form/Organization/OrganizationForm';
import unauthorizedResponse from 'portal/src/navigation/responses/unauthorizedResponse';

import { isOrganizationViewEnabled } from './adminViewEnabled';

const OrganizationView = () => {
  const { getUser, hasAdminAccess } = useAuth();
  const { organizationId } = getUser();

  if (!isOrganizationViewEnabled({ hasAdminAccess } as IAuthorizationContext)) {
    throw unauthorizedResponse();
  }

  const {
    data: org,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ['organization', organizationId],
    queryFn: () => getOrganization(organizationId),
  });

  return isFetching || isError ? (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 12,
      }}
    >
      {isFetching && <CircularProgress />}
      {isError && <span>Failed to load organization</span>}
    </Box>
  ) : (
    <OrganizationForm entity={org} isSysAdminView={false} />
  );
};

export default OrganizationView;
